export const UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE';
export const UPDATE_USER_NOTIFIED = 'UPDATE_USER_NOTIFIED';
export const UPDATE_USER_PROFILE_ERROR = 'UPDATE_USER_PROFILE_ERROR';
export const GET_USER_PROFILE = 'GET_USER_PROFILE';
export const GET_USER_PROFILE_ERROR = 'GET_USER_PROFILE_ERROR';
export const SET_LOADING = 'SET_LOADING';
export const CLEAR_USER_INFO = 'CLEAR_USER_INFO';
export const CLEAR_USER_ERROR = 'CLEAR_USER_ERROR';
